import { crmGet, crmPost, crmPut, crmPatch, crmDel, hrmsGet, fsmGet } from "../api/api";
import sessionDB from "../utils/sessionDB";

function unwrapList(response, key = "contacts") {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data?.[key])) return response.data[key];
  if (Array.isArray(response?.[key])) return response[key];
  if (Array.isArray(response?.data?.data?.[key])) return response.data.data[key];
  if (Array.isArray(response?.data?.content)) return response.data.content;
  if (Array.isArray(response?.content)) return response.content;
  if (Array.isArray(response?.data?.data?.content)) return response.data.data.content;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}


function unwrapObject(response) {
  if (response?.data && typeof response.data === "object" && !Array.isArray(response.data)) {
    // Nested envelope: { data: { data: {...} } }
    if (response.data.data && typeof response.data.data === "object" && !Array.isArray(response.data.data)) {
      return response.data.data;
    }
    return response.data;
  }
  return response || {};
}

function extractCount(response) {
  if (typeof response === "number") return response;
  if (typeof response?.count === "number") return response.count;
  if (typeof response?.data === "number") return response.data;
  if (typeof response?.data?.count === "number") return response.data.count;
  if (typeof response?.totalElements === "number") return response.totalElements;
  if (typeof response?.data?.totalElements === "number") return response.data.totalElements;
  return Number(response) || 0;
}

/** API accountStatus for create (POST). */
function normalizeStatusForCreate(statusRaw) {
  if (!statusRaw) return "Onboarding";
  const str = String(statusRaw).trim().toLowerCase().replace(/[\s-]/g, "_");
  if (str === "active") return "Active";
  if (str === "on_hold" || str === "onhold" || str === "hold") return "On_Hold";
  if (str === "inactive") return "Inactive";
  return "Onboarding";
}

// /** API accountStatus for update (PUT). */
// function normalizeStatusForUpdate(statusRaw) {
//   if (!statusRaw) return "onboarding";
//   const str = String(statusRaw).trim().toLowerCase().replace(/[\s-]/g, "_");
//   if (str === "active") return "active";
//   if (str === "on_hold" || str === "onhold" || str === "hold") return "on_hold";
//   if (str === "inactive") return "inactive";
//   return "onboarding";
// }

function normalizeStatusForUpdate(statusRaw) {
  if (!statusRaw) return "Onboarding";

  const str = String(statusRaw)
    .trim()
    .toLowerCase()
    .replace(/[\s-]/g, "_");

  if (str === "active") return "Active";
  if (str === "on_hold" || str === "onhold" || str === "hold") return "Onhold";
  if (str === "inactive") return "Inactive";

  return "Onboarding";
}

/** API accountType for create (POST). */
function normalizeAccountTypeForCreate(typeRaw) {
  if (!typeRaw) return "Normal";
  const str = String(typeRaw).trim();
  if (str === "Top Account" || str === "Top_Account") return "Top_Account";
  if (str === "Hyper Care" || str === "Hyper_Care") return "Hyper_Care";
  return "Normal";
}

/** API accountType for update (PUT). */
function normalizeAccountTypeForUpdate(typeRaw) {
  if (!typeRaw) return "Normal";
  const str = String(typeRaw).trim();
  if (str === "Top Account" || str === "Top_Account") return "Top_Account";
  if (str === "Hyper Care" || str === "Hyper_Care") return "Hyper_Care";
  return "Normal";
}

/** UI display label for accountStatus. */
export function formatAccountStatusLabel(statusRaw) {
  const str = String(statusRaw || "").trim().toLowerCase().replace(/[\s-]/g, "_");
  if (str === "active") return "Active";
  if (str === "on_hold" || str === "onhold" || str === "hold") return "On Hold";
  if (str === "inactive") return "Inactive";
  return "Onboarding";
}

function normalizeCustomerCreatePayload(payload = {}) {
  const ownerId = Number(payload.accountOwnerId || payload.account_owner_id) || 1;
  return {
    companyName: payload.companyName || payload.company_name || "",
    industryType: payload.industryType || payload.industry_type || "",
    accountType: normalizeAccountTypeForCreate(payload.accountType || payload.account_type),
    accountStatus: normalizeStatusForCreate(payload.accountStatus || payload.account_status),
    accountOwnerId: ownerId,
    accountOwner: payload.accountOwner || payload.account_owner || ""
  };
}

function normalizeCustomerUpdatePayload(payload = {}) {
  const ownerId = Number(payload.accountOwnerId || payload.account_owner_id) || 1;
  return {
    companyName: payload.companyName || payload.company_name || "",
    industryType: payload.industryType || payload.industry_type || "",
    accountType: normalizeAccountTypeForUpdate(payload.accountType || payload.account_type),
    accountStatus: normalizeStatusForUpdate(payload.accountStatus || payload.account_status),
    accountOwnerId: ownerId,
    accountOwner: payload.accountOwner || payload.account_owner || ""
  };
}

// DB check constraint / create API accepts Title-case contactType
function normalizeContactTypeForCreate(typeRaw) {
  if (!typeRaw) return "Secondary";
  const str = String(typeRaw).trim().toLowerCase();
  if (str === "primary") return "Primary";
  if (str === "secondary") return "Secondary";
  if (str === "technical") return "Technical";
  if (str === "emergency") return "Emergency";
  if (str === "general" || str === "billing" || str === "executive") return "General";
  return "Secondary";
}

// Update API expects lowercase contactType
function normalizeContactTypeForUpdate(typeRaw) {
  if (!typeRaw) return "Secondary";
  const str = String(typeRaw).trim().toLowerCase();
  if (str === "primary") return "Primary";
  if (str === "secondary") return "Secondary";
  if (str === "technical") return "Technical";
  if (str === "emergency") return "Emergency";
  if (str === "general" || str === "billing" || str === "executive") return "General";
  return "Secondary";
}

// function normalizeContactTypeForUpdate(typeRaw) {
//   if (!typeRaw) return "Secondary";

//   const str = String(typeRaw).trim().toLowerCase();

//   if (str === "primary") return "Primary";
//   if (str === "secondary") return "Secondary";
//   if (str === "technical") return "Technical";
//   if (str === "emergency") return "Emergency";
//   if (str === "general" || str === "billing" || str === "executive")
//     return "General";

//   return "Secondary";
// }

function normalizeAddContactPayload(payload = {}) {
  return {
    customerId: Number(payload.customerId || payload.customer_id),
    contactType: normalizeContactTypeForCreate(payload.contactType || payload.contact_type),
    firstName: payload.firstName || payload.first_name || "",
    lastName: payload.lastName || payload.last_name || "",
    email: payload.email || "",
    phone: payload.phone || "",
    jobTitle: payload.jobTitle || payload.job_title || "",
    isPrimary: Boolean(payload.isPrimary ?? payload.is_primary),
    receivesNotifications: Boolean(payload.receivesNotifications ?? payload.receives_notifications)
  };
}

function normalizeUpdateContactPayload(payload = {}) {
  return {
    customerId: Number(payload.customerId || payload.customer_id),
    contactType: normalizeContactTypeForUpdate(payload.contactType || payload.contact_type),
    firstName: payload.firstName || payload.first_name || "",
    lastName: payload.lastName || payload.last_name || "",
    email: payload.email || "",
    phone: payload.phone || "",
    jobTitle: payload.jobTitle || payload.job_title || "",
    isPrimary: Boolean(payload.isPrimary ?? payload.is_primary),
    receivesNotifications: Boolean(payload.receivesNotifications ?? payload.receives_notifications)
  };
}

function normalizeTaxPayload(payload = {}) {
  const tdsRaw = payload.isTdsDeductor ?? payload.is_tds_deductor;
  return {
    customerId: Number(payload.customerId || payload.customer_id),
    legalName: payload.legalName || payload.legal_name || "",
    entityType: payload.entityType || payload.entity_type || "",
    gstin: (payload.gstin || "").toString().trim().toUpperCase(),
    pan: (payload.pan || "").toString().trim().toUpperCase(),
    gstRegistrationType: payload.gstRegistrationType || payload.gst_registration_type || "",
    isTdsDeductor: tdsRaw === undefined || tdsRaw === null ? false : Boolean(tdsRaw)
  };
}

function toOptionalNumber(value) {
  if (value === undefined || value === null || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function normalizeCommercialTermsPayload(payload = {}) {
  return {
    customerId: Number(payload.customerId || payload.customer_id),
    paymentTerms: payload.paymentTerms || payload.payment_terms || "",
    paymentTermsCustomDays: toOptionalNumber(
      payload.paymentTermsCustomDays ??
        payload.payment_terms_custom_days ??
        payload.customDays ??
        payload.custom_days
    ),
    creditLimit: toOptionalNumber(payload.creditLimit ?? payload.credit_limit),
    retentionPercentage: toOptionalNumber(payload.retentionPercentage ?? payload.retention_percentage),
    retentionRelease: payload.retentionRelease || payload.retention_release || "",
    securityDepositAmount: toOptionalNumber(
      payload.securityDepositAmount ?? payload.security_deposit_amount
    ),
    billingCycle: payload.billingCycle || payload.billing_cycle || "",
    preferredPaymentMode: payload.preferredPaymentMode || payload.preferred_payment_mode || "",
    rateCardTier: payload.rateCardTier || payload.rate_card_tier || ""
  };
}

function normalizeRelationshipPayload(payload = {}) {
  const creditHoldRaw = payload.creditHold ?? payload.credit_hold;
  const ownerId = toOptionalNumber(payload.accountOwnerId ?? payload.account_owner_id);
  const body = {
    customerId: Number(payload.customerId || payload.customer_id),
    leadSource: payload.leadSource || payload.lead_source || "",
    creditRiskRating: payload.creditRiskRating || payload.credit_risk_rating || "",
    creditHold: creditHoldRaw === undefined || creditHoldRaw === null ? false : Boolean(creditHoldRaw),
    preferredContactChannel:
      payload.preferredContactChannel || payload.preferred_contact_channel || ""
  };
  if (ownerId !== null) body.accountOwnerId = ownerId;
  return body;
}

function unwrapRelationshipPage(res) {
  let records = unwrapList(res, "relationships");
  if (records.length === 0) records = unwrapList(res, "customerRelationships");
  if (records.length === 0) records = unwrapList(res, "content");
  return {
    records,
    totalPages: res?.totalPages || res?.data?.totalPages || res?.data?.data?.totalPages || 1,
    totalElements:
      res?.totalElements ||
      res?.data?.totalElements ||
      res?.data?.data?.totalElements ||
      records.length
  };
}

function buildPageQuery({ page = 0, size = 10, sortBy, sortDir, ...extra } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("size", String(size));
  if (sortBy) params.set("sortBy", sortBy);
  if (sortDir) params.set("sortDir", sortDir);
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  return `?${params.toString()}`;
}

function unwrapTaxPage(res) {
  let records = unwrapList(res, "taxInfo");
  if (records.length === 0) records = unwrapList(res, "customerTaxInfo");
  if (records.length === 0) records = unwrapList(res, "content");
  return {
    records,
    totalPages: res?.totalPages || res?.data?.totalPages || res?.data?.data?.totalPages || 1,
    totalElements:
      res?.totalElements ||
      res?.data?.totalElements ||
      res?.data?.data?.totalElements ||
      records.length
  };
}

function unwrapCommercialPage(res) {
  let records = unwrapList(res, "commercialTerms");
  if (records.length === 0) records = unwrapList(res, "customerCommercialTerms");
  if (records.length === 0) records = unwrapList(res, "content");
  return {
    records,
    totalPages: res?.totalPages || res?.data?.totalPages || res?.data?.data?.totalPages || 1,
    totalElements:
      res?.totalElements ||
      res?.data?.totalElements ||
      res?.data?.data?.totalElements ||
      records.length
  };
}

/** Coerce API/UI flag values (boolean | 0/1 | "true"/"false") to a real boolean. */
export function toBooleanFlag(value, defaultValue = false) {
  if (value === undefined || value === null || value === "") return defaultValue;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  const str = String(value).trim().toLowerCase();
  if (["true", "1", "yes", "y"].includes(str)) return true;
  if (["false", "0", "no", "n"].includes(str)) return false;
  return defaultValue;
}

/** Read billing-address flag from any known API/UI alias. */
export function extractBillingAddressFlag(source = {}, defaultValue = false) {
  return toBooleanFlag(
    source.isBillingAddress ??
      source.is_billing_address ??
      source.billingAddress ??
      source.billing_address,
    defaultValue
  );
}

/** Read asset quantity from any known API/UI alias. Returns null when missing. */
export function extractAssetQuantity(source = {}) {
  const raw =
    source.quantity ??
    source.qty ??
    source.assetQuantity ??
    source.asset_quantity;
  if (raw === undefined || raw === null || raw === "") return null;
  const num = Number(raw);
  return Number.isFinite(num) ? num : null;
}

function normalizeLocationPayload(payload = {}) {
  return {
    customerId: Number(payload.customerId || payload.customer_id),
    locationName: payload.locationName || payload.location_name || "",
    addressLine1: payload.addressLine1 || payload.address_line1 || "",
    addressLine2: payload.addressLine2 || payload.address_line2 || "",
    city: payload.city || "",
    state: payload.state || "",
    siteType: payload.siteType || payload.site_type || "",
    isActive: toBooleanFlag(payload.isActive ?? payload.is_active, true),
    // Backend column is_billing_address is NOT NULL — always send an explicit boolean.
    isBillingAddress: extractBillingAddressFlag(payload, false)
  };
}

function normalizeAssetStatus(statusRaw) {
  const str = String(statusRaw || "Active").trim();
  if (str.toLowerCase() === "inactive" || str === "InActive") return "Inactive";
  if (str === "Decommissioned" || str === "Pending_Install") return str;
  return "Active";
}

function normalizeAssetPayload(payload = {}) {
  const cleanDate = (value) => {
    const str = value == null ? "" : String(value).trim();
    return str || undefined;
  };

  const warrantyType = (payload.warrantyType || payload.warranty_type || "").trim();
  // Backend AMC type is an enum whose values use underscores (e.g. "Comprehensive",
  // "Non_Comprehensive", "No_AMC"). The UI stores the display label (with spaces),
  // so convert spaces -> underscores before sending. Sending the raw display label
  // is rejected by the backend and silently falls back to "No_AMC".
  const amcTypeDisplay = (
    payload.amcType ||
    payload.amc_type ||
    payload.AMCType ||
    payload.amctype ||
    ""
  ).trim();
  const amcTypeEnum = amcTypeDisplay ? amcTypeDisplay.replace(/\s+/g, "_") : "";
  const isNoAmc = amcTypeEnum === "No_AMC" || amcTypeDisplay === "No AMC";

  const quantity = extractAssetQuantity(payload);

  const body = {
    customerId: Number(payload.customerId || payload.customer_id),
    locationId: Number(payload.locationId || payload.location_id),
    assetName: payload.assetName || payload.asset_name || "",
    assetCategory: payload.assetCategory || payload.asset_category || "",
    manufacturer: payload.manufacturer || "",
    modelNumber: payload.modelNumber || payload.model_number || "",
    serialNumber: payload.serialNumber || payload.serial_number || "",
    warrantyType,
    assetStatus: normalizeAssetStatus(payload.assetStatus || payload.asset_status),
    // Persist quantity even though some OpenAPI snapshots omit it from the schema.
    quantity: quantity === null ? 1 : quantity
  };

  // Send under the common key spellings so whichever the backend DTO expects is populated.
  if (amcTypeEnum) {
    body.amcType = amcTypeEnum;
    body.amctype = amcTypeEnum;
    body.AMCType = amcTypeEnum;
  }

  const tenantAssetId = (
    payload.tenantAssetId ||
    payload.tenant_asset_id ||
    payload.TenantAssetId ||
    ""
  ).trim();
  if (tenantAssetId) body.tenantAssetId = tenantAssetId;

  const installDate = cleanDate(payload.installDate || payload.install_date);
  const warrantyStartDate = cleanDate(payload.warrantyStartDate || payload.warranty_start_date);
  const warrantyEnd = cleanDate(
    payload.warrantyExpiry ||
      payload.warranty_expiry ||
      payload.warrantyEndDate ||
      payload.warranty_end_date
  );

  if (installDate) body.installDate = installDate;
  if (warrantyStartDate) body.warrantyStartDate = warrantyStartDate;
  if (warrantyEnd) {
    body.warrantyExpiry = warrantyEnd;
    body.warrantyEndDate = warrantyEnd;
  }

  if (!isNoAmc) {
    const amcOrder = String(
      payload.amcOrder ||
      payload.amc_order ||
      payload.AMCOrder ||
      payload.amcOrderNo ||
      payload.amc_order_no ||
      payload.amcorderNo ||
      ""
    ).trim();
    if (amcOrder) {
      body.amcOrder = amcOrder;
      body.amcOrderNo = amcOrder;
      body.amcorderNo = amcOrder;
    }

    const amcOrderDate = cleanDate(
      payload.amcOrderDate ||
        payload.amc_order_date ||
        payload.AMCOrderDate ||
        payload.AMC_Order_Date ||
        payload.amcorderDate
    );
    if (amcOrderDate) {
      body.amcOrderDate = amcOrderDate;
      body.amcorderDate = amcOrderDate;
    }

    const amcStart = cleanDate(
      payload.AMCStartDate ||
        payload.amcStartDate ||
        payload.amc_start_date ||
        payload.AMC_Start_Date
    );
    const amcEnd = cleanDate(
      payload.AMCEndDate ||
        payload.amcEndDate ||
        payload.amc_end_date ||
        payload.AMC_End_Date
    );

    if (amcStart) {
      body.AMCStartDate = amcStart;
      body.amcstartDate = amcStart;
    }
    if (amcEnd) {
      body.AMCEndDate = amcEnd;
      body.amcendDate = amcEnd;
    }
  }

  return body;
}

function normalizeLookupOptions(payload, idKeys = ["id"], labelKeys = ["name", "label"]) {
  const candidates = [
    payload,
    payload?.data,
    payload?.content,
    payload?.result,
    payload?.data?.content,
    payload?.data?.result,
    payload?.data?.result?.content,
    payload?.records,
    payload?.items,
    payload?.rows,
    payload?.states,
    payload?.products,
    payload?.warrantyTypes,
    payload?.warranty_types,
    payload?.industryTypes,
    payload?.industry_types,
    payload?.data?.states,
    payload?.data?.products,
    payload?.data?.warrantyTypes,
    payload?.data?.warranty_types,
    payload?.data?.industryTypes,
    payload?.data?.industry_types,
    payload?.data?.content
  ];
  const list = candidates.find((value) => Array.isArray(value)) || [];

  return list
    .map((item) => {
      if (item == null) return null;
      if (typeof item === "string" || typeof item === "number") {
        const str = String(item).trim();
        return str ? { value: str, label: str } : null;
      }
      let value;
      for (const key of idKeys) {
        if (item[key] !== undefined && item[key] !== null && String(item[key]).trim() !== "") {
          value = String(item[key]);
          break;
        }
      }
      let label;
      for (const key of labelKeys) {
        if (item[key] !== undefined && item[key] !== null && String(item[key]).trim() !== "") {
          label = String(item[key]);
          break;
        }
      }
      if (!label && value) label = value;
      if (!value && label) value = label;
      if (!value || !label) return null;
      return { value, label };
    })
    .filter(Boolean);
}

/** Parse OpenAPI `pattern: "A|B|C"` into dropdown options (unescapes `\(` etc.). */
function optionsFromOpenApiPattern(pattern) {
  if (!pattern || typeof pattern !== "string") return [];
  return pattern
    .split("|")
    .map((part) => part.replace(/\\(.)/g, "$1").trim())
    .filter(Boolean)
    .map((label) => ({ value: label, label }));
}

function resolveOpenApiDocument(response) {
  if (response?.openapi) return response;
  if (response?.data?.openapi) return response.data;
  if (response?.data?.data?.openapi) return response.data.data;
  return response || {};
}

let crmOpenApiCache = null;
let crmOpenApiPromise = null;

async function loadCrmOpenApiDocument() {
  if (crmOpenApiCache) return crmOpenApiCache;
  if (crmOpenApiPromise) return crmOpenApiPromise;
  crmOpenApiPromise = crmGet("/v3/api-docs")
    .then((res) => {
      crmOpenApiCache = resolveOpenApiDocument(res);
      return crmOpenApiCache;
    })
    .catch((err) => {
      crmOpenApiPromise = null;
      throw err;
    });
  return crmOpenApiPromise;
}

function schemaFieldOptions(doc, schemaName, fieldName) {
  const props = doc?.components?.schemas?.[schemaName]?.properties || {};
  const field = props?.[fieldName];
  if (!field) return [];
  if (field.pattern) return optionsFromOpenApiPattern(field.pattern);
  if (Array.isArray(field.enum) && field.enum.length) {
    return field.enum
      .map((v) => String(v || "").trim())
      .filter(Boolean)
      .map((value) => ({ value, label: value.replace(/_/g, " ") }));
  }
  return [];
}

/** First non-empty OpenAPI field options across candidate schema names. */
function schemaFieldOptionsFromAny(doc, schemaNames, fieldName) {
  for (const schemaName of schemaNames) {
    const options = schemaFieldOptions(doc, schemaName, fieldName);
    if (options.length) return options;
  }
  return [];
}

const CUSTOMER_INFO_SCHEMA_CANDIDATES = [
  "CustomerInfoCreateRequest",
  "CustomerCreateRequest",
  "CustomerInfoRequest",
  "CustomerInfoAddRequest",
  "CustomerInfoUpdateRequest",
  "CustomerUpdateRequest",
  "CustomerDTO",
  "CustomerInfo"
];

const FALLBACK_ACCOUNT_TYPE_OPTIONS = [
  { value: "Normal", label: "Normal" },
  { value: "Top_Account", label: "Top Account" },
  { value: "Hyper_Care", label: "Hyper Care" }
];

const FALLBACK_ACCOUNT_STATUS_OPTIONS = [
  { value: "Onboarding", label: "Onboarding" },
  { value: "Active", label: "Active" },
  { value: "On_Hold", label: "On Hold" },
  { value: "Inactive", label: "Inactive" }
];

/** List-filter status values accepted by GET /customer-info/search/status. */
const FALLBACK_ACCOUNT_STATUS_FILTER_OPTIONS = [
  { value: "Onboarding", label: "Onboarding" },
  { value: "Active", label: "Active" },
  { value: "Onhold", label: "On Hold" },
  { value: "Inactive", label: "Inactive" }
];

export const customerService = {
  // 1. Get Customers List
  async getCustomers(page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = `?page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-info/search${query}`);
      const customers = unwrapList(res, "customers");
      return {
        customers,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || customers.length
      };
    } catch (err) {
      console.warn("CRM customer list API failed:", err);
      throw err;
    }
  },

  // 2. Search Customers by Company Name
  async searchByName(companyName, page = 0, size = 10, sortBy = "companyName", sortDir = "ASC") {
    try {
      const query = `?companyName=${encodeURIComponent(companyName)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-info/search/name${query}`);
      const customers = unwrapList(res, "customers");
      return {
        customers,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || customers.length
      };
    } catch (err) {
      console.warn("CRM customer search by name API failed:", err);
      throw err;
    }
  },

  // 2b. Search Customers by Account Type
  // GET /customer-info/search/{accountType}?accountType={value}&page=&size=&sortBy=&sortDir=
  async searchByAccountType(accountType, page = 0, size = 10, sortBy = "companyName", sortDir = "ASC") {
    try {
      const type = String(accountType || "").trim();
      const query =
        `?accountType=${encodeURIComponent(type)}` +
        `&page=${page}&size=${size}` +
        `&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-info/search/${encodeURIComponent(type)}${query}`);
      const customers = unwrapList(res, "customers");
      return {
        customers,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || customers.length
      };
    } catch (err) {
      console.warn("CRM customer search by account type API failed:", err);
      throw err;
    }
  },

  // 2c. Search Customers by Account Status
  // GET /customer-info/search/status?accountStatus={value}&page=&size=&sortBy=&sortDir=
  async searchByAccountStatus(accountStatus, page = 0, size = 10, sortBy = "companyName", sortDir = "ASC") {
    try {
      const status = String(accountStatus || "").trim();
      const query =
        `?accountStatus=${encodeURIComponent(status)}` +
        `&page=${page}&size=${size}` +
        `&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-info/search/status${query}`);
      const customers = unwrapList(res, "customers");
      return {
        customers,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || customers.length
      };
    } catch (err) {
      console.warn("CRM customer search by account status API failed:", err);
      throw err;
    }
  },

  // 3. Get Customer Count
  async getCustomerCount() {
    try {
      const res = await crmGet("/customer-info/count");
      return extractCount(res);
    } catch (err) {
      console.warn("CRM customer count API failed:", err);
      return 0;
    }
  },

  // 4. Get Customer By ID
  async getCustomerById(customerId) {
    try {
      const res = await crmGet(`/customer-info/${customerId}`);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM getCustomerById failed for ID ${customerId}:`, err);
      throw err;
    }
  },

  // 5. Create Customer (POST /customer-info/add)
  async createCustomer(payload) {
    try {
      const cleanPayload = normalizeCustomerCreatePayload(payload);
      const res = await crmPost("/customer-info/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createCustomer failed:", err);
      throw err;
    }
  },

  // 6. Update Customer (PUT /customer-info/update/{customerId})
  async updateCustomer(customerId, payload) {
    console.log("Update Payload:", payload);
    console.log("Account Status:", payload.accountStatus);
    console.log("Account Type:", payload.accountType);
    try {
      const cleanPayload = normalizeCustomerUpdatePayload(payload);
      const res = await crmPut(`/customer-info/update/${customerId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateCustomer failed for ID ${customerId}:`, err);
      throw err;
    }
  },

  // 7. Update Customer Status (PUT /customer-info/update/status/{customerId})
  async updateCustomerStatus(customerId, accountStatus) {
    try {
      const status = normalizeStatusForUpdate(accountStatus);
      const res = await crmPut(`/customer-info/update/status/${customerId}`, { accountStatus: status });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateCustomerStatus failed for ID ${customerId}:`, err);
      throw err;
    }
  },

  // 8. Delete Customer (DELETE /customer-info/delete/{customerId})
  async deleteCustomer(customerId) {
    try {
      return await crmDel(`/customer-info/delete/${customerId}`);
    } catch (err) {
      console.warn(`CRM deleteCustomer failed for ID ${customerId}:`, err);
      throw err;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                            CUSTOMER CONTACTS APIS                           */
  /* -------------------------------------------------------------------------- */

  // 1. Create Contact (POST /customer-contact/add - expects Title-case contactType)
  async createContact(contactPayload) {
    try {
      const cleanPayload = normalizeAddContactPayload(contactPayload);
      const res = await crmPost("/customer-contact/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createContact failed:", err);
      throw err;
    }
  },

  // 2. Update Contact (PUT /customer-contact/update/{contactId} - expects lowercase contactType)
  async updateContact(contactId, contactPayload) {
    try {
      const cleanPayload = normalizeUpdateContactPayload(contactPayload);
      const res = await crmPut(`/customer-contact/update/${contactId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateContact failed for ID ${contactId}:`, err);
      throw err;
    }
  },

  // 3. Get Contact by ID (GET /customer-contact/{contactId})
  async getContactById(contactId) {
    try {
      const res = await crmGet(`/customer-contact/${contactId}`);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM getContactById failed for ID ${contactId}:`, err);
      throw err;
    }
  },

  // 4. Get Contacts by Customer (GET /customer-contact/search/customer?customerId={id})
  async getContactsByCustomer(customerId, page = 0, size = 10, sortBy = "contactId", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-contact/search/customer${query}`);
      const contacts = unwrapList(res, "contacts");
      return {
        contacts,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || contacts.length
      };
    } catch (err) {
      console.warn(`CRM getContactsByCustomer failed for customerId ${customerId}:`, err);
      return { contacts: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 5. Search Contacts by Name (GET /customer-contact/search/name)
  async searchContactsByName(customerId, name, page = 0, size = 10, sortBy = "firstName", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&name=${encodeURIComponent(name)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-contact/search/name${query}`);
      const contacts = unwrapList(res, "contacts");
      return {
        contacts,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || contacts.length
      };
    } catch (err) {
      console.warn(`CRM searchContactsByName failed for customerId ${customerId}:`, err);
      return { contacts: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Update Primary Contact (PUT /customer-contact/update/primary/{contactId})
  async updatePrimaryContact(contactId, isPrimary = true) {
    try {
      const res = await crmPut(`/customer-contact/update/primary/${contactId}`, { isPrimary });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updatePrimaryContact failed for contactId ${contactId}:`, err);
      throw err;
    }
  },

  // 7. Update Notification Preference (PUT /customer-contact/update/notifications/{contactId})
  async updateNotificationPreference(contactId, receivesNotifications = true) {
    try {
      const res = await crmPut(`/customer-contact/update/notifications/${contactId}`, { receivesNotifications });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateNotificationPreference failed for contactId ${contactId}:`, err);
      throw err;
    }
  },

  // 8. Get Contact Count by Customer (GET /customer-contact/count/customer?customerId={id})
  async getContactCountByCustomer(customerId) {
    try {
      const res = await crmGet(`/customer-contact/count/customer?customerId=${encodeURIComponent(customerId)}`);
      return extractCount(res);
    } catch (err) {
      console.warn(`CRM getContactCountByCustomer failed for customerId ${customerId}:`, err);
      return 0;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                          CUSTOMER LOCATIONS APIS                            */
  /* -------------------------------------------------------------------------- */

  // 1. Create Location (POST /customer-locations/add)
  async createLocation(locationPayload) {
    try {
      const cleanPayload = normalizeLocationPayload(locationPayload);
      const res = await crmPost("/customer-locations/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createLocation failed:", err);
      throw err;
    }
  },

  // 2. Update Location (PUT /customer-locations/update/{locationId})
  async updateLocation(locationId, locationPayload) {
    try {
      const cleanPayload = normalizeLocationPayload(locationPayload);
      // Update schema does not include customerId — send only updatable fields.
      const { customerId: _customerId, ...updateBody } = cleanPayload;
      const res = await crmPut(`/customer-locations/update/${locationId}`, updateBody);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateLocation failed for locationId ${locationId}:`, err);
      throw err;
    }
  },

  // Convenience: create vs update based on presence of locationId
  async saveLocation(customerId, locationPayload) {
    const payload = {
      ...locationPayload,
      customerId: Number(customerId || locationPayload.customerId || locationPayload.customer_id)
    };
    const locationId = locationPayload.id || locationPayload.locationId || locationPayload.location_id;
    if (locationId) {
      return this.updateLocation(locationId, payload);
    }
    return this.createLocation(payload);
  },

  // 3. Get Location by ID (GET /customer-locations/{locationId})
  async getLocationById(locationId) {
    try {
      const res = await crmGet(`/customer-locations/${locationId}`);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM getLocationById failed for locationId ${locationId}:`, err);
      throw err;
    }
  },

  // 4. Get Locations by Customer (GET /customer-locations/search/customer)
  async getLocationsByCustomer(customerId, page = 0, size = 10, sortBy = "locationId", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-locations/search/customer${query}`);
      const locations = unwrapList(res, "locations");
      return {
        locations,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || locations.length
      };
    } catch (err) {
      console.warn(`CRM getLocationsByCustomer failed for customerId ${customerId}:`, err);
      return { locations: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 5. Search Locations by Name (GET /customer-locations/search/name)
  async searchLocationsByName(customerId, locationName, page = 0, size = 10, sortBy = "locationName", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&locationName=${encodeURIComponent(locationName)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-locations/search/name${query}`);
      const locations = unwrapList(res, "locations");
      return {
        locations,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || locations.length
      };
    } catch (err) {
      console.warn(`CRM searchLocationsByName failed for customerId ${customerId}:`, err);
      return { locations: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Toggle Active Status (PATCH /customer-locations/update/status/{locationId})
  async toggleLocationStatus(locationId, isActive = true) {
    try {
      const res = await crmPatch(`/customer-locations/update/status/${locationId}`, { isActive: Boolean(isActive) });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM toggleLocationStatus failed for locationId ${locationId}:`, err);
      throw err;
    }
  },

  // 7. Location Count by Customer (GET /customer-locations/count/customer)
  async getLocationCountByCustomer(customerId) {
    try {
      const res = await crmGet(`/customer-locations/count/customer?customerId=${encodeURIComponent(customerId)}`);
      return extractCount(res);
    } catch (err) {
      console.warn(`CRM getLocationCountByCustomer failed for customerId ${customerId}:`, err);
      return 0;
    }
  },

  // 8. Delete Location (DELETE /customer-locations/delete/{locationId})
  async deleteLocation(locationId) {
    try {
      return await crmDel(`/customer-locations/delete/${locationId}`);
    } catch (err) {
      console.warn(`CRM deleteLocation failed for locationId ${locationId}:`, err);
      throw err;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                          CUSTOMER ASSETS APIS                               */
  /* -------------------------------------------------------------------------- */

  // 1. Create Asset (POST /customer-assets/add)
  async createAsset(assetPayload) {
    try {
      const cleanPayload = normalizeAssetPayload(assetPayload);
      const res = await crmPost("/customer-assets/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createAsset failed:", err);
      throw err;
    }
  },

  // 2. Update Asset (PUT /customer-assets/update/{assetId})
  async updateAsset(assetId, assetPayload) {
    try {
      const cleanPayload = normalizeAssetPayload(assetPayload);
      const res = await crmPut(`/customer-assets/update/${assetId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateAsset failed for assetId ${assetId}:`, err);
      throw err;
    }
  },

  // Convenience: create vs update based on presence of assetId
  async saveAsset(customerId, assetPayload) {
    const payload = {
      ...assetPayload,
      customerId: Number(customerId || assetPayload.customerId || assetPayload.customer_id)
    };
    const assetId = assetPayload.id || assetPayload.assetId || assetPayload.asset_id;
    if (assetId) {
      return this.updateAsset(assetId, payload);
    }
    return this.createAsset(payload);
  },

  // 3. Get Asset by ID (GET /customer-assets/{assetId})
  async getAssetById(assetId) {
    try {
      const res = await crmGet(`/customer-assets/${assetId}`);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM getAssetById failed for assetId ${assetId}:`, err);
      throw err;
    }
  },

  // 4. Get Assets by Customer (GET /customer-assets/search/customer)
  async getAssetsByCustomer(customerId, page = 0, size = 100, sortBy = "assetId", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-assets/search/customer${query}`);
      // Support varied response envelopes (assets / content / nested data)
      let assets = unwrapList(res, "assets");
      if (assets.length === 0) {
        assets = unwrapList(res, "customerAssets");
      }
      return {
        assets,
        totalPages: res?.totalPages || res?.data?.totalPages || res?.data?.data?.totalPages || 1,
        totalElements:
          res?.totalElements ||
          res?.data?.totalElements ||
          res?.data?.data?.totalElements ||
          assets.length
      };
    } catch (err) {
      console.warn(`CRM getAssetsByCustomer failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  // 5. Get Assets by Customer and Location (GET /customer-assets/search/customer-location)
  async getAssetsByCustomerAndLocation(customerId, locationId, page = 0, size = 10, sortBy = "assetId", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&locationId=${encodeURIComponent(locationId)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-assets/search/customer-location${query}`);
      const assets = unwrapList(res, "assets");
      return {
        assets,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || assets.length
      };
    } catch (err) {
      console.warn(`CRM getAssetsByCustomerAndLocation failed for customerId ${customerId}, locationId ${locationId}:`, err);
      return { assets: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Search Assets by Name (GET /customer-assets/search/name)
  async searchAssetsByName(customerId, assetName, page = 0, size = 10, sortBy = "assetName", sortDir = "ASC") {
    try {
      const query = `?customerId=${encodeURIComponent(customerId)}&assetName=${encodeURIComponent(assetName)}&page=${page}&size=${size}&sortBy=${encodeURIComponent(sortBy)}&sortDir=${encodeURIComponent(sortDir)}`;
      const res = await crmGet(`/customer-assets/search/name${query}`);
      const assets = unwrapList(res, "assets");
      return {
        assets,
        totalPages: res?.totalPages || res?.data?.totalPages || 1,
        totalElements: res?.totalElements || res?.data?.totalElements || assets.length
      };
    } catch (err) {
      console.warn(`CRM searchAssetsByName failed for customerId ${customerId}:`, err);
      return { assets: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 7. Update Asset Status (PATCH /customer-assets/update/status/{assetId})
  async updateAssetStatus(assetId, assetStatus) {
    try {
      const res = await crmPatch(`/customer-assets/update/status/${assetId}`, { assetStatus });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateAssetStatus failed for assetId ${assetId}:`, err);
      throw err;
    }
  },

  // 8. Relocate Asset (PATCH /customer-assets/update/relocate/{assetId})
  async relocateAsset(assetId, locationId) {
    try {
      const res = await crmPatch(`/customer-assets/update/relocate/${assetId}`, {
        locationId: Number(locationId)
      });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM relocateAsset failed for assetId ${assetId}:`, err);
      throw err;
    }
  },

  // 9. Asset Count by Customer (GET /customer-assets/count/customer)
  async getAssetCountByCustomer(customerId) {
    try {
      const res = await crmGet(`/customer-assets/count/customer?customerId=${encodeURIComponent(customerId)}`);
      return extractCount(res);
    } catch (err) {
      console.warn(`CRM getAssetCountByCustomer failed for customerId ${customerId}:`, err);
      return 0;
    }
  },

  // 10. Delete Asset (DELETE /customer-assets/delete/{assetId})
  async deleteAsset(assetId) {
    try {
      return await crmDel(`/customer-assets/delete/${assetId}`);
    } catch (err) {
      console.warn(`CRM deleteAsset failed for assetId ${assetId}:`, err);
      throw err;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                         LOOKUP / DROPDOWN HELPERS                          */
  /* -------------------------------------------------------------------------- */

  // GET /saas/hrms/org/states?tenantId={tenantId}
  async getOrgStates() {
    try {
      const tenantId = sessionDB.getTenantId() || 1;
      const res = await hrmsGet(`/org/states?tenantId=${encodeURIComponent(tenantId)}`, "HR14A");
      return normalizeLookupOptions(
        res,
        ["stateId", "state_id", "id"],
        ["stateName", "state_name", "name", "label"]
      );
    } catch (err) {
      console.warn("CRM getOrgStates failed:", err);
      return [];
    }
  },

  // GET /saas/hrms/org/industry_types?tenantId={tenantId}
  async getIndustryTypeOptions() {
    try {
      const tenantId = sessionDB.getTenantId() || 1;
      const res = await hrmsGet(
        `/org/industry_types?tenantId=${encodeURIComponent(tenantId)}`,
        "HR14A"
      );
      const options = normalizeLookupOptions(
        res,
        ["industryTypeId", "industry_type_id", "industryId", "industry_id", "id", "typeId", "type_id"],
        [
          "industryType",
          "industry_type",
          "industryTypeName",
          "industry_type_name",
          "industryName",
          "industry_name",
          "typeName",
          "type_name",
          "name",
          "label"
        ]
      );
      // Persist display label into customer.industryType (existing API string field)
      return options.map((opt) => ({ value: opt.label, label: opt.label, id: opt.value }));
    } catch (err) {
      console.warn("CRM getIndustryTypeOptions failed:", err);
      return [];
    }
  },

  // GET /saas/fsm/products-services/search?page=0&size=10&sortBy=productServiceId&sortDir=ASC
  async getAssetCategoryOptions(page = 0, size = 10) {
    try {
      const query = `?page=${page}&size=${size}&sortBy=productServiceId&sortDir=ASC`;
      const res = await fsmGet(`/products-services/search${query}`, "FSM01S");
      const options = normalizeLookupOptions(
        res,
        ["productServiceId", "id", "product_service_id"],
        ["productServiceName", "product_service_name", "serviceName", "systemName", "name", "label", "category"]
      );
      // Prefer human-readable labels as selectable values for assetCategory persistence
      return options.map((opt) => ({ value: opt.label, label: opt.label, id: opt.value }));
    } catch (err) {
      console.warn("CRM getAssetCategoryOptions failed:", err);
      return [];
    }
  },

  // GET /saas/hrms/org/warranty_types?tenantId={tenantId}
  async getWarrantyTypeOptions() {
    try {
      const tenantId = sessionDB.getTenantId() || 1;
      const res = await hrmsGet(`/org/warranty_types?tenantId=${encodeURIComponent(tenantId)}`, "HR14A");
      const options = normalizeLookupOptions(
        res,
        ["warrantyTypeId", "warranty_type_id", "id", "typeId", "type_id"],
        ["warrantyType", "warranty_type", "warrantyTypeName", "warranty_type_name", "typeName", "type_name", "name", "label"]
      );
      // Persist display label into asset.warrantyType (API string field)
      return options.map((opt) => ({ value: opt.label, label: opt.label, id: opt.value }));
    } catch (err) {
      console.warn("CRM getWarrantyTypeOptions failed:", err);
      return [];
    }
  },

  /**
   * Tax dropdown options from CRM OpenAPI schema patterns
   * (CustomerTaxInfoCreateRequest) — no separate master-data lookup APIs exist.
   */
  async getTaxInfoDropdownOptions() {
    try {
      const doc = await loadCrmOpenApiDocument();
      return {
        entityType: schemaFieldOptions(doc, "CustomerTaxInfoCreateRequest", "entityType"),
        gstRegistrationType: schemaFieldOptions(doc, "CustomerTaxInfoCreateRequest", "gstRegistrationType")
      };
    } catch (err) {
      console.warn("CRM getTaxInfoDropdownOptions failed:", err);
      throw err;
    }
  },

  /**
   * Commercial Terms dropdown options from CRM OpenAPI schema patterns
   * (CustomerCommercialTermsCreateRequest).
   */
  async getCommercialTermsDropdownOptions() {
    try {
      const doc = await loadCrmOpenApiDocument();
      return {
        paymentTerms: schemaFieldOptions(doc, "CustomerCommercialTermsCreateRequest", "paymentTerms"),
        retentionRelease: schemaFieldOptions(doc, "CustomerCommercialTermsCreateRequest", "retentionRelease"),
        billingCycle: schemaFieldOptions(doc, "CustomerCommercialTermsCreateRequest", "billingCycle"),
        preferredPaymentMode: schemaFieldOptions(
          doc,
          "CustomerCommercialTermsCreateRequest",
          "preferredPaymentMode"
        ),
        rateCardTier: schemaFieldOptions(doc, "CustomerCommercialTermsCreateRequest", "rateCardTier")
      };
    } catch (err) {
      console.warn("CRM getCommercialTermsDropdownOptions failed:", err);
      throw err;
    }
  },

  /**
   * Relationship dropdown options from CRM OpenAPI schema patterns
   * (CustomerRelationshipCreateRequest).
   */
  async getRelationshipDropdownOptions() {
    try {
      const doc = await loadCrmOpenApiDocument();
      return {
        leadSource: schemaFieldOptions(doc, "CustomerRelationshipCreateRequest", "leadSource"),
        creditRiskRating: schemaFieldOptions(doc, "CustomerRelationshipCreateRequest", "creditRiskRating"),
        preferredContactChannel: schemaFieldOptions(
          doc,
          "CustomerRelationshipCreateRequest",
          "preferredContactChannel"
        )
      };
    } catch (err) {
      console.warn("CRM getRelationshipDropdownOptions failed:", err);
      throw err;
    }
  },

  /**
   * Account Type / Account Status dropdown options from CRM OpenAPI schema
   * (customer-info create/update request). No dedicated master-data lookup APIs
   * exist; search endpoints filter customers by a selected value:
   *   GET /customer-info/search/{accountType}?accountType=...
   *   GET /customer-info/search/status?accountStatus=...
   */
  async getCustomerInfoDropdownOptions() {
    try {
      const doc = await loadCrmOpenApiDocument();
      const accountType =
        schemaFieldOptionsFromAny(doc, CUSTOMER_INFO_SCHEMA_CANDIDATES, "accountType") || [];
      const accountStatus =
        schemaFieldOptionsFromAny(doc, CUSTOMER_INFO_SCHEMA_CANDIDATES, "accountStatus") || [];

      const typeOptions = accountType.length ? accountType : FALLBACK_ACCOUNT_TYPE_OPTIONS;
      const statusOptions = accountStatus.length ? accountStatus : FALLBACK_ACCOUNT_STATUS_OPTIONS;

      // List filters: prefer API "Onhold" spelling when schema only has On_Hold
      const statusFilterOptions = statusOptions.map((opt) => {
        const key = String(opt.value || "")
          .trim()
          .toLowerCase()
          .replace(/[\s-]/g, "_");
        if (key === "on_hold" || key === "onhold" || key === "hold") {
          return { value: "Onhold", label: opt.label || "On Hold" };
        }
        return { value: opt.value, label: opt.label || String(opt.value).replace(/_/g, " ") };
      });

      return {
        accountType: typeOptions.map((opt) => ({
          value: opt.value,
          label: opt.label || String(opt.value).replace(/_/g, " ")
        })),
        accountStatus: statusOptions.map((opt) => ({
          value: opt.value,
          label: opt.label || String(opt.value).replace(/_/g, " ")
        })),
        accountStatusFilter: statusFilterOptions.length
          ? statusFilterOptions
          : FALLBACK_ACCOUNT_STATUS_FILTER_OPTIONS
      };
    } catch (err) {
      console.warn("CRM getCustomerInfoDropdownOptions failed:", err);
      return {
        accountType: FALLBACK_ACCOUNT_TYPE_OPTIONS,
        accountStatus: FALLBACK_ACCOUNT_STATUS_OPTIONS,
        accountStatusFilter: FALLBACK_ACCOUNT_STATUS_FILTER_OPTIONS
      };
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                         CUSTOMER TAX INFO APIS                              */
  /* -------------------------------------------------------------------------- */

  // 1. Create Tax Info (POST /customer-tax-info/add) — one record per customer
  async createTaxInfo(taxPayload) {
    try {
      const cleanPayload = normalizeTaxPayload(taxPayload);
      const res = await crmPost("/customer-tax-info/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createTaxInfo failed:", err);
      throw err;
    }
  },

  // 2. Update Tax Info (PUT /customer-tax-info/update/{customerId})
  async updateTaxInfo(customerId, taxPayload) {
    try {
      const cleanPayload = normalizeTaxPayload({ ...taxPayload, customerId });
      const res = await crmPut(`/customer-tax-info/update/${customerId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateTaxInfo failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  /**
   * Create or update tax info for a customer (single record).
   * Uses GET to detect existence; 404 / empty → create, else update.
   */
  async saveTaxLegal(customerId, taxPayload) {
    const payload = { ...taxPayload, customerId: Number(customerId) };
    const existing = await this.getTaxInfoByCustomerId(customerId);
    if (existing) {
      return this.updateTaxInfo(customerId, payload);
    }
    return this.createTaxInfo(payload);
  },

  // 3. Get Tax Info by Customer ID (GET /customer-tax-info/{customerId})
  async getTaxInfoByCustomerId(customerId) {
    try {
      const res = await crmGet(`/customer-tax-info/${customerId}`);
      const obj = unwrapObject(res);
      if (!obj || (typeof obj === "object" && !Object.keys(obj).length)) return null;
      // Some APIs return { message } on not found with 200
      if (obj.message && !obj.legalName && !obj.legal_name && !obj.customerId && !obj.customer_id) {
        return null;
      }
      return obj;
    } catch (err) {
      const status = err?.status || err?.response?.status || err?.statusCode;
      if (status === 404 || status === 204) return null;
      console.warn(`CRM getTaxInfoByCustomerId failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  // 4. Search all tax info (GET /customer-tax-info/search)
  async searchTaxInfo(page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir });
      const res = await crmGet(`/customer-tax-info/search${query}`);
      return unwrapTaxPage(res);
    } catch (err) {
      console.warn("CRM searchTaxInfo failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 5. Filter by TDS deductor (GET /customer-tax-info/search/tds-deductor)
  async searchTaxInfoByTdsDeductor(isTdsDeductor, page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({
        page,
        size,
        sortBy,
        sortDir,
        isTdsDeductor: Boolean(isTdsDeductor)
      });
      const res = await crmGet(`/customer-tax-info/search/tds-deductor${query}`);
      return unwrapTaxPage(res);
    } catch (err) {
      console.warn("CRM searchTaxInfoByTdsDeductor failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Get by PAN (GET /customer-tax-info/search/pan)
  async getTaxInfoByPan(pan) {
    try {
      const res = await crmGet(`/customer-tax-info/search/pan?pan=${encodeURIComponent(pan)}`);
      return unwrapObject(res);
    } catch (err) {
      const status = err?.status || err?.response?.status || err?.statusCode;
      if (status === 404) return null;
      console.warn("CRM getTaxInfoByPan failed:", err);
      throw err;
    }
  },

  // 7. Search by legal name (GET /customer-tax-info/search/legal-name)
  async searchTaxInfoByLegalName(legalName, page = 0, size = 10, sortBy = "legalName", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, legalName });
      const res = await crmGet(`/customer-tax-info/search/legal-name${query}`);
      return unwrapTaxPage(res);
    } catch (err) {
      console.warn("CRM searchTaxInfoByLegalName failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 8. Get by GSTIN (GET /customer-tax-info/search/gstin)
  async getTaxInfoByGstin(gstin) {
    try {
      const res = await crmGet(`/customer-tax-info/search/gstin?gstin=${encodeURIComponent(gstin)}`);
      return unwrapObject(res);
    } catch (err) {
      const status = err?.status || err?.response?.status || err?.statusCode;
      if (status === 404) return null;
      console.warn("CRM getTaxInfoByGstin failed:", err);
      throw err;
    }
  },

  // 9. Filter by GST registration type (GET /customer-tax-info/search/gst-registration-type)
  async searchTaxInfoByGstRegistrationType(
    gstRegistrationType,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, gstRegistrationType });
      const res = await crmGet(`/customer-tax-info/search/gst-registration-type${query}`);
      return unwrapTaxPage(res);
    } catch (err) {
      console.warn("CRM searchTaxInfoByGstRegistrationType failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 10. Filter by entity type (GET /customer-tax-info/search/entity-type)
  async searchTaxInfoByEntityType(entityType, page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, entityType });
      const res = await crmGet(`/customer-tax-info/search/entity-type${query}`);
      return unwrapTaxPage(res);
    } catch (err) {
      console.warn("CRM searchTaxInfoByEntityType failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 11. Total tax info count (GET /customer-tax-info/count)
  async getTaxInfoCount() {
    try {
      const res = await crmGet("/customer-tax-info/count");
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getTaxInfoCount failed:", err);
      return 0;
    }
  },

  // 12. Count by TDS deductor (GET /customer-tax-info/count/tds-deductor)
  async getTaxInfoCountByTdsDeductor(isTdsDeductor) {
    try {
      const res = await crmGet(
        `/customer-tax-info/count/tds-deductor?isTdsDeductor=${encodeURIComponent(Boolean(isTdsDeductor))}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getTaxInfoCountByTdsDeductor failed:", err);
      return 0;
    }
  },

  // 13. Count by entity type (GET /customer-tax-info/count/entity-type)
  async getTaxInfoCountByEntityType(entityType) {
    try {
      const res = await crmGet(
        `/customer-tax-info/count/entity-type?entityType=${encodeURIComponent(entityType)}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getTaxInfoCountByEntityType failed:", err);
      return 0;
    }
  },

  // 14. Delete Tax Info (DELETE /customer-tax-info/delete/{customerId})
  async deleteTaxInfo(customerId) {
    try {
      return await crmDel(`/customer-tax-info/delete/${customerId}`);
    } catch (err) {
      console.warn(`CRM deleteTaxInfo failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      CUSTOMER COMMERCIAL TERMS APIS                         */
  /* -------------------------------------------------------------------------- */

  // 1. Create Commercial Terms (POST /customer-commercial-terms/add)
  async createCommercialTerms(termsPayload) {
    try {
      const cleanPayload = normalizeCommercialTermsPayload(termsPayload);
      const res = await crmPost("/customer-commercial-terms/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createCommercialTerms failed:", err);
      throw err;
    }
  },

  // 2. Update Commercial Terms (PUT /customer-commercial-terms/update/{customerId})
  async updateCommercialTerms(customerId, termsPayload) {
    try {
      const cleanPayload = normalizeCommercialTermsPayload({ ...termsPayload, customerId });
      const res = await crmPut(`/customer-commercial-terms/update/${customerId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateCommercialTerms failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  /**
   * Create or update commercial terms (single record per customer).
   */
  async saveCommercialTerms(customerId, termsPayload) {
    const payload = { ...termsPayload, customerId: Number(customerId) };
    const existing = await this.getCommercialTermsByCustomerId(customerId);
    if (existing) {
      return this.updateCommercialTerms(customerId, payload);
    }
    return this.createCommercialTerms(payload);
  },

  // 3. Get by Customer ID (GET /customer-commercial-terms/{customerId})
  async getCommercialTermsByCustomerId(customerId) {
    try {
      const res = await crmGet(`/customer-commercial-terms/${customerId}`);
      const obj = unwrapObject(res);
      if (!obj || (typeof obj === "object" && !Object.keys(obj).length)) return null;
      if (
        obj.message &&
        !obj.paymentTerms &&
        !obj.payment_terms &&
        !obj.customerId &&
        !obj.customer_id
      ) {
        return null;
      }
      return obj;
    } catch (err) {
      const status = err?.status || err?.response?.status || err?.statusCode;
      if (status === 404 || status === 204) return null;
      console.warn(`CRM getCommercialTermsByCustomerId failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  // 4. Search all (GET /customer-commercial-terms/search)
  async searchCommercialTerms(page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir });
      const res = await crmGet(`/customer-commercial-terms/search${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTerms failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 5. Filter by retention release
  async searchCommercialTermsByRetentionRelease(
    retentionRelease,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, retentionRelease });
      const res = await crmGet(`/customer-commercial-terms/search/retention-release${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTermsByRetentionRelease failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Filter by rate card tier
  async searchCommercialTermsByRateCardTier(
    rateCardTier,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, rateCardTier });
      const res = await crmGet(`/customer-commercial-terms/search/rate-card-tier${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTermsByRateCardTier failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 7. Filter by payment terms
  async searchCommercialTermsByPaymentTerms(
    paymentTerms,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, paymentTerms });
      const res = await crmGet(`/customer-commercial-terms/search/payment-terms${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTermsByPaymentTerms failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 8. Filter by preferred payment mode
  async searchCommercialTermsByPaymentMode(
    preferredPaymentMode,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, preferredPaymentMode });
      const res = await crmGet(`/customer-commercial-terms/search/payment-mode${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTermsByPaymentMode failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 9. Filter by billing cycle
  async searchCommercialTermsByBillingCycle(
    billingCycle,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, billingCycle });
      const res = await crmGet(`/customer-commercial-terms/search/billing-cycle${query}`);
      return unwrapCommercialPage(res);
    } catch (err) {
      console.warn("CRM searchCommercialTermsByBillingCycle failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 10. Total count
  async getCommercialTermsCount() {
    try {
      const res = await crmGet("/customer-commercial-terms/count");
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getCommercialTermsCount failed:", err);
      return 0;
    }
  },

  // 11. Count by rate card tier
  async getCommercialTermsCountByRateCardTier(rateCardTier) {
    try {
      const res = await crmGet(
        `/customer-commercial-terms/count/rate-card-tier?rateCardTier=${encodeURIComponent(rateCardTier)}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getCommercialTermsCountByRateCardTier failed:", err);
      return 0;
    }
  },

  // 12. Count by billing cycle
  async getCommercialTermsCountByBillingCycle(billingCycle) {
    try {
      const res = await crmGet(
        `/customer-commercial-terms/count/billing-cycle?billingCycle=${encodeURIComponent(billingCycle)}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getCommercialTermsCountByBillingCycle failed:", err);
      return 0;
    }
  },

  // 13. Delete (DELETE /customer-commercial-terms/delete/{customerId})
  async deleteCommercialTerms(customerId) {
    try {
      return await crmDel(`/customer-commercial-terms/delete/${customerId}`);
    } catch (err) {
      console.warn(`CRM deleteCommercialTerms failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      CUSTOMER RELATIONSHIP APIS                             */
  /* -------------------------------------------------------------------------- */

  // 1. Create (POST /customer-relationship/add)
  async createRelationship(relationshipPayload) {
    try {
      const cleanPayload = normalizeRelationshipPayload(relationshipPayload);
      const res = await crmPost("/customer-relationship/add", cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn("CRM createRelationship failed:", err);
      throw err;
    }
  },

  // 2. Update (PUT /customer-relationship/update/{customerId})
  async updateRelationship(customerId, relationshipPayload) {
    try {
      const cleanPayload = normalizeRelationshipPayload({ ...relationshipPayload, customerId });
      const res = await crmPut(`/customer-relationship/update/${customerId}`, cleanPayload);
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateRelationship failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  /** Create or update relationship (single record per customer). */
  async saveRelationship(customerId, relationshipPayload) {
    const payload = { ...relationshipPayload, customerId: Number(customerId) };
    const existing = await this.getRelationshipByCustomerId(customerId);
    if (existing) {
      return this.updateRelationship(customerId, payload);
    }
    return this.createRelationship(payload);
  },

  // 3. Toggle credit hold (PATCH /customer-relationship/update/credit-hold/{customerId})
  async updateRelationshipCreditHold(customerId, creditHold) {
    try {
      const res = await crmPatch(`/customer-relationship/update/credit-hold/${customerId}`, {
        creditHold: Boolean(creditHold)
      });
      return unwrapObject(res);
    } catch (err) {
      console.warn(`CRM updateRelationshipCreditHold failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  // 4. Get by customer ID (GET /customer-relationship/{customerId})
  async getRelationshipByCustomerId(customerId) {
    try {
      const res = await crmGet(`/customer-relationship/${customerId}`);
      const obj = unwrapObject(res);
      if (!obj || (typeof obj === "object" && !Object.keys(obj).length)) return null;
      if (
        obj.message &&
        !obj.leadSource &&
        !obj.lead_source &&
        !obj.customerId &&
        !obj.customer_id
      ) {
        return null;
      }
      return obj;
    } catch (err) {
      const status = err?.status || err?.response?.status || err?.statusCode;
      if (status === 404 || status === 204) return null;
      console.warn(`CRM getRelationshipByCustomerId failed for customerId ${customerId}:`, err);
      throw err;
    }
  },

  // 5. Search all
  async searchRelationships(page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir });
      const res = await crmGet(`/customer-relationship/search${query}`);
      return unwrapRelationshipPage(res);
    } catch (err) {
      console.warn("CRM searchRelationships failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 6. Filter by lead source
  async searchRelationshipsByLeadSource(leadSource, page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, leadSource });
      const res = await crmGet(`/customer-relationship/search/lead-source${query}`);
      return unwrapRelationshipPage(res);
    } catch (err) {
      console.warn("CRM searchRelationshipsByLeadSource failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 7. Filter by credit risk
  async searchRelationshipsByCreditRisk(
    creditRiskRating,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, creditRiskRating });
      const res = await crmGet(`/customer-relationship/search/credit-risk${query}`);
      return unwrapRelationshipPage(res);
    } catch (err) {
      console.warn("CRM searchRelationshipsByCreditRisk failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 8. Filter by credit hold
  async searchRelationshipsByCreditHold(creditHold, page = 0, size = 10, sortBy = "customerId", sortDir = "ASC") {
    try {
      const query = buildPageQuery({
        page,
        size,
        sortBy,
        sortDir,
        creditHold: Boolean(creditHold)
      });
      const res = await crmGet(`/customer-relationship/search/credit-hold${query}`);
      return unwrapRelationshipPage(res);
    } catch (err) {
      console.warn("CRM searchRelationshipsByCreditHold failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 9. Filter by preferred contact channel
  async searchRelationshipsByContactChannel(
    preferredContactChannel,
    page = 0,
    size = 10,
    sortBy = "customerId",
    sortDir = "ASC"
  ) {
    try {
      const query = buildPageQuery({ page, size, sortBy, sortDir, preferredContactChannel });
      const res = await crmGet(`/customer-relationship/search/contact-channel${query}`);
      return unwrapRelationshipPage(res);
    } catch (err) {
      console.warn("CRM searchRelationshipsByContactChannel failed:", err);
      return { records: [], totalPages: 1, totalElements: 0 };
    }
  },

  // 10. Total count
  async getRelationshipCount() {
    try {
      const res = await crmGet("/customer-relationship/count");
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getRelationshipCount failed:", err);
      return 0;
    }
  },

  // 11. Count by lead source
  async getRelationshipCountByLeadSource(leadSource) {
    try {
      const res = await crmGet(
        `/customer-relationship/count/lead-source?leadSource=${encodeURIComponent(leadSource)}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getRelationshipCountByLeadSource failed:", err);
      return 0;
    }
  },

  // 12. Count by credit risk
  async getRelationshipCountByCreditRisk(creditRiskRating) {
    try {
      const res = await crmGet(
        `/customer-relationship/count/credit-risk?creditRiskRating=${encodeURIComponent(creditRiskRating)}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getRelationshipCountByCreditRisk failed:", err);
      return 0;
    }
  },

  // 13. Count by credit hold
  async getRelationshipCountByCreditHold(creditHold) {
    try {
      const res = await crmGet(
        `/customer-relationship/count/credit-hold?creditHold=${encodeURIComponent(Boolean(creditHold))}`
      );
      return extractCount(res);
    } catch (err) {
      console.warn("CRM getRelationshipCountByCreditHold failed:", err);
      return 0;
    }
  },

  // 14. Delete (DELETE /customer-relationship/delete/{customerId})
  async deleteRelationship(customerId) {
    try {
      return await crmDel(`/customer-relationship/delete/${customerId}`);
    } catch (err) {
      console.warn(`CRM deleteRelationship failed for customerId ${customerId}:`, err);
      throw err;
    }
  }
};
